import { render, staticRenderFns } from "./ReservationDeskspaces.vue?vue&type=template&id=03712280&scoped=true"
import script from "./ReservationDeskspaces.vue?vue&type=script&lang=js"
export * from "./ReservationDeskspaces.vue?vue&type=script&lang=js"
import style0 from "./ReservationDeskspaces.vue?vue&type=style&index=0&id=03712280&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03712280",
  null
  
)

export default component.exports